import { render, staticRenderFns } from "./m_certificateDetail.vue?vue&type=template&id=a6be64de&scoped=true&"
import script from "./m_certificateDetail.vue?vue&type=script&lang=js&"
export * from "./m_certificateDetail.vue?vue&type=script&lang=js&"
import style0 from "./m_certificateDetail.vue?vue&type=style&index=0&id=a6be64de&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6be64de",
  null
  
)

export default component.exports